import React, { Component } from 'react';

import classes from './QuickReply.module.css';
import Button from '../Button/Button';

class QuickReply extends Component{

  state={
    disabled: false
  }

  componentDidMount(){
    // focusing the first button of new quickreply
    this.firstButton.button.focus();
  }

  clickHandler = (value) => {
    if(!this.state.disabled){

      // In this pryect we don't want to disable quickreply buttons
      // because most of buttons are external links
      //
      // this.setState(prevState=>({
      //   disabled: !prevState.disabled
      // }));
      
      if (value) this.props.selected(value);

    }
  }

  render(){

    const messageClasses = [
      classes[`${this.props.origin}-message`],
      classes.QuickReply
    ];

    if (this.props.payload.buttons.length > 2) {
      messageClasses.push(classes.VerticalButtons);
    }

    const options = this.props.payload.buttons.map((btn, index)=>(
      <li key={index}>
         <Button 
            ref={index === 0 ? (button) => { this.firstButton = button; } : null} 
            click= {this.clickHandler}
            style= {this.props.buttonStyle}
            disabled={this.state.disabled} 
            {...btn}
            />
      </li>
    ))

    return (
      <ul className={messageClasses.join(' ')} style={this.props.style}>
        {options}
      </ul>
    )
  }
  
}



export default QuickReply;